export default "__VITE_ASSET__B930ZpAn__"